var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.loading,
          expression: "!loading",
        },
      ],
    },
    [
      _vm.success
        ? _c(
            "wa-message",
            {
              attrs: {
                theme: "success",
                "icon-name": "faFaceSmile",
                type: "flash",
                "custom-style": {
                  "--message-margin": " var(--spacing-lg) 0 0 0",
                },
              },
            },
            [
              _c(
                "template",
                { slot: "content" },
                [
                  _c("strong", [_vm._v("You made something awesome!")]),
                  _vm._v("  Visit your Kit to\n      "),
                  _c(
                    "site-link",
                    {
                      staticClass: "link fa-navy",
                      attrs: {
                        to: {
                          name: "kits.kit.customicons",
                          params: {
                            token: _vm.selectedKit,
                            icon: _vm.iconName,
                          },
                        },
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.$posthog.capture(
                            "icon_wizard_view_new_icon_link_click"
                          )
                        },
                      },
                    },
                    [_vm._v("\n        view your new icon\n      ")]
                  ),
                  _vm._v("\n      .\n    "),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isSignedIn && _vm.isPro && !_vm.hasKits
        ? _c(
            "wa-message",
            {
              attrs: {
                theme: "danger",
                "icon-name": "faExclamationTriangle",
                "custom-style": {
                  "--message-margin": " var(--spacing-lg) 0 0 0",
                },
              },
            },
            [
              _c(
                "template",
                { slot: "content" },
                [
                  _vm._v("\n      No Kits found. Go\n      "),
                  _c(
                    "site-link",
                    {
                      staticClass: "link fa-navy",
                      attrs: { to: { name: "kits" } },
                    },
                    [_vm._v("\n        create a Kit\n      ")]
                  ),
                  _vm._v("\n      and give it another try.\n    "),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.duplicateError
        ? _c(
            "wa-message",
            {
              attrs: {
                theme: "warning",
                "icon-name": "faExclamationTriangle",
                type: "flash",
                "custom-style": {
                  "--message-margin": " var(--spacing-lg) 0 0 0",
                },
              },
            },
            [
              _c(
                "template",
                { slot: "content" },
                [
                  _vm._v("\n      You already have that\n      "),
                  _c(
                    "site-link",
                    {
                      staticClass: "link fa-navy",
                      attrs: {
                        to: {
                          name: "kits.kit.icons",
                          params: {
                            token: _vm.selectedKit,
                            icon: _vm.iconName,
                          },
                        },
                      },
                    },
                    [_vm._v("\n        icon\n      ")]
                  ),
                  _vm._v("\n      in the Kit you selected!\n    "),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.errorMessage != ""
        ? _c(
            "wa-message",
            {
              attrs: {
                theme: "danger",
                "icon-name": "faSkullCrossbones",
                type: "flash",
                "custom-style": {
                  "--message-margin": " var(--spacing-lg) 0 0 0",
                },
              },
            },
            [
              _c("template", { slot: "content" }, [
                _vm._v("\n      " + _vm._s(_vm.errorMessage) + "\n    "),
              ]),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }